import React from "react";

import { formatCurrency } from "../lib/formato";

const PARTES = [
  { key: "cmv", nome: "CMV", cor: "bg-red-500" },
  { key: "despesas", nome: "Despesas", cor: "bg-amber-500" },
  { key: "lucro", nome: "Lucro", cor: "bg-emerald-500" },
];

// Para onde foi cada real vendido: CMV | despesas | lucro, lado a lado.
// Com prejuízo, a barra inteira é custo (a base passa a ser CMV + despesas).
export default function BarraResultado({ m, altura = "h-2.5", legenda = false }) {
  const lucro = Math.max(m.lucro, 0);
  const base = Math.max(m.faturamento, m.cmv + m.despesas, 0.01);
  const valores = { cmv: m.cmv, despesas: m.despesas, lucro };
  return (
    <div>
      <div className={`flex w-full ${altura} rounded-full overflow-hidden bg-muted`} title="CMV · Despesas · Lucro">
        {PARTES.map((p) => valores[p.key] > 0 && (
          <div key={p.key} className={`${p.cor} h-full`} style={{ width: `${(valores[p.key] / base) * 100}%` }}
            title={`${p.nome}: ${formatCurrency(valores[p.key])}`} />
        ))}
      </div>
      {legenda && (
        <div className="flex flex-wrap gap-x-4 gap-y-1 mt-2 text-[11px] text-muted-foreground">
          {PARTES.map((p) => (
            <span key={p.key} className="inline-flex items-center gap-1.5"><span className={`w-2.5 h-2.5 rounded-sm ${p.cor}`} />{p.nome}</span>
          ))}
        </div>
      )}
    </div>
  );
}

export const corMargem = (m) => (m == null ? "text-muted-foreground bg-muted"
  : m >= 30 ? "text-emerald-700 dark:text-emerald-300 bg-emerald-500/15"
    : m >= 15 ? "text-amber-700 dark:text-amber-300 bg-amber-500/15" : "text-red-700 dark:text-red-300 bg-red-500/15");
